module.exports = __webpack_public_path__ + "infocentrum24.jpg?253c496c00fa6b69761ca1c8da8f1ea2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum24.jpg
// module id = 276
// module chunks = 0